import { Component, Input, forwardRef } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'

export interface VcRadioOption {
   label: string
   value: any
}

@Component({
   selector: 'vc-radio-group',
   templateUrl: './radio-group.component.html',
   styleUrls: ['./radio-group.component.scss'],
   standalone: false,
   providers: [
      {
         provide: NG_VALUE_ACCESSOR,
         useExisting: forwardRef(() => VcRadioGroupComponent),
         multi: true,
      },
   ],
})
export class VcRadioGroupComponent implements ControlValueAccessor {
   @Input() label = ''
   @Input() infoTooltip = ''
   @Input() options: VcRadioOption[] = []
   @Input() disabled = false
   @Input() direction: 'row' | 'column' = 'row'
   @Input() required = false
   @Input() yesno = false
   @Input() isInline = false
   @Input() radiobutton = false
   @Input() groupName = ''

   value: any = null
   onChange = (_: any) => {}
   onTouched = () => {}

   writeValue(v: any) {
      this.value = v
   }
   registerOnChange(fn: any) {
      this.onChange = fn
   }
   registerOnTouched(fn: any) {
      this.onTouched = fn
   }
   setDisabledState(isDisabled: boolean) {
      this.disabled = isDisabled
   }
}
